import styled from 'styled-components';

const lightGray = '#D3D3D3';
const darkGray = '#4D4D4D';
const black = '#000000';

export const Container = styled.label`
  outline: none;
`;

type FieldParams = {
  toClipboard?: boolean;
  error?: boolean;
  required?: boolean;
};

export const Label = styled.p`
  display: block;
  font-size: 1rem;
  line-height: 1;
  padding-bottom: 0.5rem;
`;

export const Field = styled.input<FieldParams>`
  border: 1px solid #eee;
  display: block;
  width: 100%;
  font-size: 1rem;
  padding: 0.8rem;
  border-radius: 4px;
  background-color: ${lightGray};
  color: ${black};
  transition: 0.2s;
  border: 1px solid ${({ error }) => (error ? '#FF0000' : lightGray)};

  outline: none;

  &[type='checkbox'] {
    width: auto;
    height: min-content;
    cursor: pointer;
    &:hover {
      box-shadow: none;
    }
    + span {
      position: unset;
    }
  }

  &:focus:not(:read-only) {
    background-color: transparent;
    &:not([type='checkbox']) + span {
      color: ${({ error }) => (error ? '#FF0000' : black)};
    }
  }

  &:focus,
  &:not(:placeholder-shown) {
    &:not([type='checkbox']) {
      background-color: transparent;
    }
  }

  &::placeholder {
    color: ${darkGray};
    font-family: 'Arial, sans-serif';
    opacity: 1;
    font-weight: 400;
  }
`;

export const FieldArea = styled.textarea<FieldParams>`
  border: 1px solid #eee;
  display: block;
  width: 100%;
  font-size: 1rem;
  padding: 0.8rem;
  border-radius: 4px;
  background-color: ${lightGray};
  color: ${black};
  transition: 0.2s;
  border: 1px solid ${({ error }) => (error ? '#FF0000' : lightGray)};
  outline: none;

  &:focus:not(:read-only) {
    background-color: transparent;
    &:not([type='checkbox']) + span {
      color: ${({ error }) => (error ? '#FF0000' : black)};
    }
  }

  &:focus,
  &:not(:placeholder-shown) {
    &:not([type='checkbox']) {
      background-color: transparent;
    }
  }

  &::placeholder {
    color: ${darkGray};
    font-family: 'Arial, sans-serif';
    opacity: 1;
    font-weight: 400;
  }
`;
